import React, { useEffect, useRef, useState } from "react";
import { Input, InputRef, message } from "antd";

interface TimeInputProps {
  value?: string;
  onChange?: (value: string) => void;
  disabled?: boolean;
  placeholder?: string;
}

const pad = (val: string) => val.padStart(2, "0");

const formatTime = (str: string): string => {
  const digits = str.replace(/[^\d]/g, "").slice(0, 4);
  const parts = digits.match(/.{1,2}/g) || [];

  const [hh = "00", mm = "00"] = parts;

  const hour = Math.min(Number(hh) || 0, 23);
  const minute = Math.min(Number(mm) || 0, 59);

  return `${pad(hour.toString())}:${pad(minute.toString())}`;
};

const TimeInput: React.FC<TimeInputProps> = ({
  value = "",
  onChange,
  disabled = false,
  placeholder,
}) => {
  const [input, setInput] = useState(value);
  const inputRef = useRef<InputRef>(null);

  console.log(value);

  useEffect(() => {
    setInput(value || "");
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value;

    if (/[^0-9:]/.test(raw)) {
      message.error("Faqat raqamlar va ':' belgisi kiritilishi mumkin");
      return;
    }

    const digits = raw.replace(/[^\d]/g, "").slice(0, 4);
    let formatted = "";

    for (let i = 0; i < digits.length; i++) {
      formatted += digits[i];
      if (i === 1 && i !== digits.length - 1) formatted += ":";
    }

    setInput(formatted);
    onChange?.(formatted);
  };

  const handleBlur = () => {
    if (!input?.trim()) return;

    const normalized = formatTime(input);
    setInput(normalized);
    onChange?.(normalized);
  };

  return (
    <Input
      ref={inputRef}
      value={input}
      onChange={handleChange}
      onBlur={handleBlur}
      disabled={disabled}
      placeholder={placeholder || "00:00"}
      allowClear
      maxLength={5}
    />
  );
};

export default TimeInput;
